import { render, staticRenderFns } from "./SimplePoints.vue?vue&type=template&id=6d851881&scoped=true&"
import script from "./SimplePoints.vue?vue&type=script&lang=ts&"
export * from "./SimplePoints.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePoints.vue?vue&type=style&index=0&id=6d851881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d851881",
  null
  
)

export default component.exports